
const toHours = m => m < 60 ? m + ' minutes' : Math.round((m / 60) * 100) / 100 + ' hours';

export default toHours;
